const superUrlEncoder = require("./super-url-encoder.util")

const createAnalyticImgPath = (target, type, field, value) => {
  const targetLst = target.split("~")
  const name = targetLst[0]
  const width = targetLst[1]
  return `${name}~${type}~${field}~${superUrlEncoder(value)}~${width}`
}

module.exports = createAnalyticImgPath